import PBKDF2 from "crypto-js/pbkdf2";
import Utf8 from "crypto-js/enc-utf8";
import AES from "crypto-js/aes";
import { encryptionKeys } from "./constants";


const PassPhrase = encryptionKeys.PassPhrase
const SaltValue = encryptionKeys.SaltValue
const InitVector = encryptionKeys.InitialVector
const PasswordIterations = +encryptionKeys.PasswordIterations
const Blocksize = +encryptionKeys.BlockSize


// Encryption Service

export const encryptRequest = (request: any) => {

    var key = PBKDF2(PassPhrase, Utf8.parse(SaltValue), {
        keySize: 256 / Blocksize,
        iterations: PasswordIterations,
    });
    var parsedIV = Utf8.parse(InitVector);

    // Encrypt
    var encrypted = AES.encrypt(JSON.stringify(request), key, {
        iv: parsedIV,
    }).toString()
    
    return encrypted;
};

// Decryption Service

export const decryptResponse = (response: any) => {

    var key = PBKDF2(PassPhrase, Utf8.parse(SaltValue), {
        keySize: 256 / Blocksize,
        iterations: PasswordIterations,
    });
    var parsedIV = Utf8.parse(InitVector);

    // Decrypt
    var bytes = AES.decrypt(response, key, { iv: parsedIV });
    var decryptedResponse = bytes.toString(Utf8);

    if(decryptedResponse){
        return JSON.parse(decryptedResponse);
    }
    else{
        return decryptedResponse
    }

};